module.exports = __webpack_public_path__ + "img/sitem_bg4.29a1f111.png";